module.exports = __webpack_public_path__ + "static/icons/icon-snow-history--white-7875c5e72108654cd13805d05589a1d8.svg";